<template>
  <div style="width: 100%; height: 100%;display:flex">
    <div class="mapWrap" >
      <iframe id="mapframe" src="../../../static/EvMap/playback.html?name=John" width="100%" height="100%" style="border: 0px"></iframe>
    </div>

    <div class='changeAirSpace'>
      <!-- 右侧 -->
      <div class="airSpaceBtnOne">
        <div
          title="空域"
          class="chooseBtn"
          :class="airSpaceChecked ? 'active' : ''"
          @click="
            airSpaceChecked = !airSpaceChecked;
            area = !area;
            btClick.space= area?btClick.space:false;
            handleBtClick('area',area);
          "
        >
          <img
            :src="
              require(`../../assets/img/2dmap/${
                airSpaceChecked
                  ? 'kong_yu_click'
                  : 'kong_yu_normal'
              }.png`)
            "
            alt=""
          />
        </div>
<!--        <div
          title="设备"
          class="chooseBtn"
          :class="shibeiChecked ? 'active' : ''"
          @click="
            shibeiChecked = !shibeiChecked;
            equip=!equip
          "
        >
          <img
            :src="
              require(`../../assets/img/2dmap/${
                shibeiChecked ? 'she_bei_click' : 'she_bei_normal'
              }.png`)
            "
            alt=""
          />
        </div>-->
        <div
          title="航线/飞行"
          class="chooseBtn"
          :class="airPointLineChecked ? 'active' : ''"
          @click="
            airPointLineChecked = !airPointLineChecked;
            airPointLine = !airPointLine;
            btClick.airline= airPointLine?btClick.airline:false;
            handleBtClick('airPointLine',airPointLine);
          "
        >
          <img
            :src="
              require(`../../assets/img/2dmap/${
                airPointLineChecked ? 'fei_xing_click' : 'fei_xing_normal'
              }.png`)
            "
            alt=""
          />
        </div>
      </div>
    </div>
    <div class='changeAirSpace1'>
      <!-- 右侧 -->
      <div class="airSpaceBtn" style="width: 100%;height: 100%;">

        <div v-show="area" class="area">
          <div
            class="chooseBtn"
            :class="btClick.space ? 'Active' : 'noActive'"
            @click="
              btClick.space= !btClick.space;
              btClick.airline= btClick.space?false:btClick.airline;
              handleBtClick('space',btClick.space);
            "
          >
            <div>空域</div>
          </div>
          <div class='changeWithOpenXianArea1'></div>
        </div>
<!--        <div v-show="equip" class="equip">
          <div class="chooseBtn" :class="btClick.adsb ? 'Active' : 'noActive'" @click="
              btClick.adsb= !btClick.adsb;
              handleBtClick('adsb',btClick.adsb);">
            <div>ADSB侦察</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.zhence ? 'Active' : 'noActive'" @click="
              btClick.zhence= !btClick.zhence;
              handleBtClick('zhence',btClick.zhence);"
          >
            <div>侦测设备</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.weather ? 'Active' : 'noActive'"  @click="
              btClick.weather= !btClick.weather;
              handleBtClick('weather',btClick.weather);"
          >
            <div>气象设备</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.video ? 'Active' : 'noActive'"
            @click="
              btClick.video= !btClick.video;
              handleBtClick('video',btClick.video);"
          >
            <div>视频设备</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.navigator ? 'Active' : 'noActive'"
            @click="
              btClick.navigator= !btClick.navigator;
              handleBtClick('navigator',btClick.navigator);"
          >
            <div>导航设备</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.communicator ? 'Active' : 'noActive'"
            @click="
              btClick.communicator= !btClick.communicator;
              handleBtClick('communicator',btClick.communicator);"
          >
            <div>通信设备</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.range ? 'Active' : 'noActive'"
            @click="
              btClick.range= !btClick.range;
              handleBtClick('range',btClick.range);"
          >
            <div>设备范围</div>
          </div>
          <div class='changeWithOpenXianArea'>

          </div>
        </div>-->
        <div v-show="airPointLine" class="airPointLine1">
          <div
            class="chooseBtn"
            :class="btClick.airline ? 'Active' : 'noActive'" @click="
              btClick.airline= !btClick.airline;
              btClick.space= btClick.airline?false:btClick.space;
              handleBtClick('airline',btClick.airline);"
          >
            <div>航线</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.track ? 'Active' : 'noActive'" @click="
              btClick.track= !btClick.track;
              handleBtClick('track',btClick.track);"
          >
            <div>航迹</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.marker ? 'Active' : 'noActive'" @click="
              btClick.marker= !btClick.marker;
              handleBtClick('marker',btClick.marker);"
          >
            <div>标牌</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.detailMarker ? 'Active' : 'noActive'"
            @click="
              btClick.detailMarker= !btClick.detailMarker;
              handleBtClick('detailMarker',btClick.detailMarker);"
          >
            <div>详细标牌</div>
          </div>
          <div class='changeWithOpenXianArea1'>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import PlanDetail from "../../common/PlanDetail";
import Empty from "../../common/Empty.vue";
export default {
  name: "ThreedPlayback",
  components: {
    PlanDetail,
    Empty
  },
  data() {
    return {
      planViewData:{},//飞行概览数据
      planActivity:{},//飞行活动数据
      aircraftData:{detail:[]},//飞行器数据
      taskForm:{},
      clickButton:false,
      searchTaskKeyWord:'',
      taskList:[],
      timeInfo: {
        currentTime: "10:04:06",
        date: "2020-10-20",
        weekday: "星期一"
      },
      chartType: 1,//右侧折线图切换1.运行小时数2.运行架次3.运行里程
      leftTop:null,
      rightCenter:null,
      rightBottom:null,
      rightTop:null,
      rightTopData:[],
      leftTopData:[],
      rightCenterData:[],
      rightBottomData:[],
      bottomClick:'2',
      runTask: [], //执行中计划
      preTask: [], //待执行计划
      doneTask: [], //已执行计划
      realTask:[],//实时事件
      changeRunTask: [], //处理后的计划
      searchDoneTask:'',
      searchRealTask:'',
      searchPreTask:'',
      // 存储被点击的id
      startIds:[],
      changeIds:[],
      downIds:[],
      facilitiesData:{},//地面基础设施数据
      loginUrl:!location.hostname.toString().includes('192.168.205')?'http://220.248.31.148:9601':"http://192.168.205.105:9601",//本地地址
      inspectionHistory:{arr:[]},//巡检历史统计数据
      inspectionWeek:{},//巡检当周统计数据
      inspectionDefect:[],//巡检缺陷史统计数据
      inspectionKey:'e3dea0f5-37f2-4d79-ae58-490af3228069',//巡检key
      openLeft:true,//是否展开左侧计划列表
      ws: null,
      airSpaceChecked: false,
      shibeiChecked: false,
      airPointLineChecked: false,
      area: false,
      equip: false,
      airPointLine: false,
      btClick:{
        space:false,
        grid:false,
        adsb:false,
        zhence:false,
        weather:false,
        video:false,
        navigator:false,
        communicator:false,
        range:false,
        airline:false,
        track: true,
        marker: true,
        detailMarker:false
      }
    };
  },
  watch:{
    runTask(){
      this.changeRunTask = this.runTask.map(v=>({...v,startChecked:false,changeChecked:false,downChecked:false}))
    }
  },
  mounted() {
    this.initWs();
    this.queryPlan();
    window.queryTaskTimer = setInterval(()=>{
      this.queryPlan();
    }, 20000);
  },
  beforeDestroy(){
    clearInterval(window.queryTaskTimer)
  },
  methods:{
    // 生成随机字符串
    generateRandomString(length = 10) {
      const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return result;
    },
    initWs(){
      let randomStr = this.generateRandomString();
      //  this.ws = new WebSocket(`ws://${location.hostname}:9600/websocket/login/${WebsocketUtil.websocketId}`); //线上
      this.ws = new WebSocket(`ws://${location.hostname}:9600/websocket/login/${randomStr}`); //线上
      this.ws.addEventListener('open', () => {
        console.log('ws连接成功');
        // 建立连接成功后发送token给后端
        // let token = sessionStorage.getItem('tokenId');
        // this.ws.send('Authorization: Bearer ' + token);
        // 发送屏幕对角线数据给后端
        // this.sendBounds();
      });
      this.ws.addEventListener('close', () => {
        console.log('ws连接关闭');
        // 连接断开后停止预测点的定时器
        if (window.predictionTimer) {
          clearInterval(window.predictionTimer);
          window.predictionTimer = null;
        }
      });
      this.ws.addEventListener('error', (err) => {
        console.log('ws连接错误', err);
      });
      this.ws.addEventListener('message', (e) => {
        let data = JSON.parse(e.data);
        let records = data.content;
        let realTask = [];//告警信息
        if (data.type == 1) {
          records.map(po => {
            if (po.warning || po.alarm) {
              let warnMes = `${po.uasID}在${po.routeName}上发生偏航${
                po.warning ? "预警" : "告警"
              }`;
              realTask.unshift({
                warnMes: warnMes,
                warning: po.warning,
                alarm: po.alarm,
                uasID: po.uasID
              });
            }
            if (po.black) {
              let warnMes = `${po.uasID}正在黑飞告警`;
              realTask.unshift({
                warnMes: warnMes,
                warning: 0,
                alarm: 1,
                uasID: po.uasID
              });
            }
            if (po.conflictsList && po.conflictsList.length) {
              //aow ture 告警 false 预警
              po.conflictsList.map(v => {
                realTask.unshift({
                  warnMes: v.conflict,
                  warning: !v.aow,
                  uasID: po.uasID
                });
              })
            }
          })
        } else if (data.type == 2) {
          realTask.unshift({
            warnMes: records.content,
            warning: records.alarmType == 0 ? 1 : 0,
          });
        } else if (data.type == 11) {
          Airspace.refreshAirSpace();
        } else if (data.type == 12) {
          Channel.refreshChannelLine();
        }
        this.realTask = realTask.concat(this.realTask);
        if(this.realTask.length>10){
          let num = this.realTask.length - 10
          for(let i = 0;i<num;i++){
            this.realTask.pop()
          }
        }
      });
    },
    showPlanDetail(info){
      console.log(info)
      this.taskForm = info
      this.clickButton = true
    },
    updateDialogVisible(newVal){
      this.clickButton = newVal
    },
    closeForm(value){
      this.clickButton = value
    },
    searchClick(v){
      this.queryPlan(v);
    },
    queryPlan() {
      this.getRequest(
        `/uav-task-server/plandto/queryPlanByConditionNoStatus?pagesize=100&keyWord=${this.searchTaskKeyWord}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let records = oData.data.list;
          if (records && records.length > 0) {
            // let simpleArray = records.map(item => ({
            //   id: item.id,
            //   planSerial: item.planSerial,
            //   uavSerial: item.uavSerial,
            //   uavModel: item.uavModel,
            //   pilot: item.pilot,
            //   type: item.type,
            //   status: item.status,
            //   airpointList: item.airpointList
            // }));
            this.taskList = records;
          } else {
            this.taskList = [];
          }
        } else {
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            },
          });
        }
      });
    },
    sendMessageToIframe(code , data){
      let message = {code:code, data:data};
      let iframe = document.getElementById('mapframe');
      if (iframe.contentWindow) {
        // 发送消息到iframe
        iframe.contentWindow.postMessage(message, '*'); // 注意目标来源地址
      }
    },
    handleBtClick(key, value){
      let data={key:key, value:value};
      this.sendMessageToIframe(1, data);
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: 'PangMenZhengDao-3';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

@font-face {
  font-family: 'PangMenZhengDao-3-Regular';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}


#dashboardIndex {
  z-index: 3;
  width: 100%;
  height: 100%;
  position: relative;
}
/* 两侧以及底部顶部z-index 为4  header为3 高于地图 */
.mapWrap{

  z-index: 2;
  position: absolute;
  top:80px;
  left:0;
  width: 100%;
  height: calc(100% - 80px);
  overflow: hidden;
}
.headerContent{
  pointer-events:none;
  z-index: 3;
  width: 100%;
  background-size: 100%;
  display: flex;
  justify-content: end;
  padding: 16px 22px 0 17px;
//position: relative;
  position: absolute;
}
@media screen and (max-width: 1920px) {
  .headerContent{
    height: 144px;
    background-image: url("../../assets/img/dashboard/header.png");
  }
  .headerMiddle{
    font-size: 66px;
    line-height: 60px;
  }
}
@media screen and (min-width: 2000px) {
  .headerContent{
    height: 240px;
    background-image: url("../../assets/img/dashboard/header_2880.png");
  }
  .headerMiddle{
    line-height: 100px;
    font-size: 100px;
  }
}
.headerLeft{
  position: absolute;
  left: 17px;
  top: 16px;
  z-index: 5;
  display: flex;
}
.headerBtn{
  width: 120px;
  height: 40px;
  background-image: url("../../assets/img/dashboard/menu_btn.png");
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  text-shadow: 2px 2px 2px 2px rgba(0,0,0,0.18);
  line-height: 40px;
  cursor: pointer;
}
.headerMiddle{
//width: 1388px;
  position: absolute;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 2.64px;
  text-shadow: 2px 3.46px 3.68px 0.32px rgba(16,9,0,0.50);
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.headerRight{
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #f0f0f0;
  letter-spacing: 1.4px;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
  margin-top: 10px;
}

.contentWrap{
  position: absolute;
  top: 80px;
  height: calc(100% - 80px);
  width: 100%;
}
.leftContent{
  top: 0;
  left: 0;

}
.rightContent{
  top: 0;
  right: 0;
}
.leftContent,
.rightContent{
  z-index: 4;
  background: rgba(16,10,1,0.78);
  height: 100%;
//width: 20%;
  width: 400px;
  position: absolute;
  display: flex;
  flex-direction: column;
//overflow: auto;
}

.rightContent{
  right: 0;

}
.bottomContent{
  z-index: 4;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  width: calc(100% - 800px);
  justify-content: space-around;
}
.bottomBtn,.bottomBtnClick{
  cursor: pointer;
  text-align: center;
  line-height: 74px;
  width: 233px;
  height: 74px;
  font-size: 32px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 1.6px;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
}
.bottomBtn{
  background-image: url("../../assets/img/dashboard/normal.png");
}
.bottomBtnClick{
  background-image: url("../../assets/img/dashboard/click.png");
}
.contentItem{
  height: 66%;
  min-height: 325px;
  display: flex;
  flex-direction: column;
}
.contentItem10{
  height: 33%;
//min-height: 100px;
  display: flex;
  flex-direction: column;
}
.contentItem30{
  flex: 30;
  max-height: 26%;
  display: flex;
  flex-direction: column;
}
.itemTitle{
  height: 50px;
  background-image: url("../../assets/img/2dmap/pop_bg.png");
  background-size: 80% 38px;
  padding-left: 44px;
  background-repeat: no-repeat;
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
  margin-top: 12px;
}
.barChart,.lineChart{
  flex: 1;
  margin-top: 11px;
}
.inspectionContentWrap{
  padding: 23px 21px 0 29px;
  height: calc(100% - 50px);
}
#patrolHistory{
  background-image: url('../../assets/img/dashboard/shuju_bg2.png');
  width: 350px;
  height: 92px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
}
#patrolHistory .historyItem{
  width: 110px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 0 15px 0 15px;
}
#patrolHistory .historyItem:not(:last-child){
  border-right: 2px solid;
  border-image: linear-gradient(0deg, rgba(238,175,84,0.00), rgba(255,200,119,0.99) 49%, rgba(255,200,119,0.00)) 2 2;

}
#patrolDefect{
  padding: 13px 23px 23px 34px;
  width: 350px;
  height: 92px;
  display: flex;
  justify-content: center;
  background-image: url('../../assets/img/dashboard/shuju_bg.png');
}
#patrolDefect .dayItem{
  width: 120px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 0 15px 0 15px;
}
.data{
//margin-bottom: 5px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ebebeb;
}
.text{
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.checkData{
  border-bottom: 2px solid ;
  border-image: linear-gradient(0deg, rgba(255, 200, 119, 0.99), rgba(255, 200, 119, 0.00) 49%, rgba(238, 175, 84, 0.00)) 2 2;
  font-size: 30px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffc877;
  margin-bottom: 8px;
}
.separate{
  border-right: 2px solid;
  border-image: linear-gradient(0deg, rgba(238,175,84,0.00), rgba(255,200,119,0.99) 49%, rgba(255,200,119,0.00)) 2 2;
}
.alarmWrap{
  height: calc(100% - 50px);
  padding: 0 33px 23px 27px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.alarmContentWrap{
  display: flex;
  justify-content: space-between;
}
.alertItem{
  background-size: 100%;
  position: relative;
  width: 140px;
  height: 132px;
}
.alertItemText{
  position: absolute;
  font-size: 18px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: center;
  color: #ffffff;
  bottom: 6px;
  left: 34px;
}
.alertItemFigure{
  height: 17px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  text-shadow: 1px 1.73px 5px 2px rgba(20,10,0,0.68);
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
}
#heiFeiItem{
  background-image: url("../../assets/img/dashboard/hei_fei.png");
}
#chongTuItem{
  background-image: url("../../assets/img/dashboard/chong_tu.png");
}
#pianHangItem{
  background-image: url("../../assets/img/dashboard/pian_hang.png");
}
#zhengChangItem{
  background-image: url("../../assets/img/dashboard/zheng_chang.png");
}
.basic{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 50px);
  padding: 30px 34px 27px 24px;
}
.equipment{
  display: flex;
}
.up{
  background-image: url(../.././assets/img/dashboard/tubiao_chengse.png);
  background-position: top left;
  background-repeat: no-repeat;
  height: 98px;
  width: 98px;
  margin-right: 60px;
  position: relative;
}
.watch{
  background-image: url(../.././assets/img/dashboard/tubiao_jinse.png);
  background-position: top left;
  background-repeat: no-repeat;
  height: 98px;
  width: 98px;
  position: relative;
}
.datas{
  position: absolute;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
//text-align: left;
  color: #ffffff;
//z-index: 99;
  left: 57px;
  top: 10px;
}
.equipment .texts{
  min-width: 130px;
  position: absolute;
  left: 58px;
  top: 40px;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
//text-align: left;
  color: #ebebeb;
//z-index: 99;
}
.states{
  display: flex;
}
.states .texts{
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.down{
  width: 159px;
  height: 132px;
  background: rgba(23,11,1,0.50);
  border: 2px solid rgba(255,200,119,0.30);
  margin-top: 5px;
}
.stateone{
  display: flex;
  margin-top: 12px;
}
.txt{
  width: 100%;
  height: 42%;
  font-size: 18px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ffffff;
  padding-left: 11px;
  padding-top: 15px;
}
.numbers{
  width: 45px;
  height: 17px;
  line-height: 17px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffc877;
  margin-left: 45px;
}
.numberstwo{
  width: 20px;
  height: 17px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ff5555;
  margin-left: 45px;
}
.fa-mouse-pointer {
  cursor: pointer;
}
.lineChartWrap{
  flex:1;
  height: calc(100% - 92px);
}
.linkBtn{
  position: relative;
}
.linksGroup{
  position: absolute;
  left: 35px;
  top:-60px;
  width: 170px;
  height: 55px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.linksGroup a{
  line-height: 22px;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  font-size: 24px;
  font-family: 'PangMenZhengDao-3', 'PangMenZhengDao-3-Regular';
  font-weight: 400;
  text-decoration: underline;
  text-align: left;
  color: #ffc877;
}
.taskcontent_2d{
  padding: 5px 10px;
  height: 100%;
  overflow: auto;
}
.taskSearchBox{
  margin-bottom: 12px;
}

>>>.taskSearchBox .el-input__inner {
  color: #FFFFFF;
  border-radius: 0;
  border: none;
}

.taskSearchBox >>>input{
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: calc(100% - 5px);
  height: 32px;
  background: rgba(0, 174, 255, 0.5);
  font-size: 14px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
}
.taskSearchBox  /deep/.el-input__icon{
  height: 32px;
//border: 1px solid red;
  right: 10px;
  line-height: 38px;
  cursor: pointer;

}
.taskSearchBox input{

}
.taskSearchBox input >>>i{
//border: 1px solid red;
  position: absolute;
  top: 7px;
  bottom: 7px;
  right: 32px;
}
.task-item_2d {
  margin: 16px 0;
  cursor: pointer;
}
.task-item_2d .common{
  background: rgba(1, 10, 18, 0.68);
  height: 38px;
  color: #FFFFFF;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 10px
}

.task-item_2d .donePlan {
  border: 2px solid #ee3f3f;
}

.task-item_2d .prePlan {
  border: 2px solid #00aeff;
}

.task-item_2d .executePlan {
  border: 2px solid #00ffff;
}
.taskWrap{
  background: rgba(1, 10, 18, 0.68);
  border-radius: 6px;
  padding: 8px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: calc(100% - 62px)
}

.common .firstSpan{
  min-width: 90px;
}
.common .secondSpan{
  min-width: 50px;
}
.common .thirdSpan{
  min-width: 40px;
}
.common .itemDetail{
  width: 6px;
  height: 10px;
  background-image: url("../../assets/img/2dmap/xiang_qing.png");
}
/*.task-item_2d  .donePlan{
  background: #220c03;
}
.task-item_2d  .prePlan{
  background: #2d0a0a;
}
.task-item_2d  .executePlan{
  background: #2f1d0b;
}*/
.prePlan:hover{
  box-shadow: 0px 0px 6px 1px #ff5555 inset;
}
.executePlan:hover{
  box-shadow: 0px 0px 6px 1px #ffc877 inset;
}
.donePlan:hover{
  box-shadow: 0px 0px 6px 1px deepskyblue inset;
}
.task-item_2d .planeBtns{
  padding-right: 5px;
  display: flex;
}
.emptyContent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex: 1;
  width: 100%;
  background: #170b01;
  border-radius: 6px;
  font-size: 14px;
  color: #fff;
}
.planeBtns .planTobtn{
  display: flex;
  align-items: center;
  position: relative;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  cursor: pointer;
  z-index: 1001;
}
.planeBtns .planTobtn:not(:last-child){
  margin-right: 6px;
}
.planTobtn img{
  width: 26px;
  height: 26px;
}
.planeBtns .planTobtn span {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 35px;
  background-color: #333;
  color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  z-index: 100;
}
.planeBtns .planTobtn:hover span {
  display: block;
}
.listAll_2d{
  height: calc(100% - 44px);
  padding: 0 10px;
  background: rgba(1, 10, 18, 0.50);
  overflow: auto;
}
.emptyWrap{
  width: 100%;
  height: calc(100% - 44px);
}
#rightOverlay {
  width: 400px !important;
}
*{
  user-select: none;
}
.flyTop {
  padding: 13px 23px 23px 34px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px 22px 18px 22px;
  width: 350px;
  height: 92px;
  /* background-image: url("../../assets/img/2dmap/shuju_bg.png"); */
  background-image: url('../../assets/img/dashboard/shuju_bg.png');
}

.flyTopTop div:nth-child(1) {
  font-size: 30px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffc877;
  text-align: left;
}

.flyTopTop div:nth-child(2) {
  width: 100px;
  height: 15px;
}
.fa-mouse-pointer {
  cursor: pointer;
}
.canChangeFigure {
  height: 40px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;

}
.flyTop .flyText {
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
#fenge {
  display: block;
  width: 70px;
  height: 0;
  border: 2px solid;
  border-image: linear-gradient(0deg, rgba(238, 175, 84, 0.00), rgba(255, 200, 119, 0.99) 49%, rgba(255, 200, 119, 0.00)) 2 2;
}
.flyTop .unActiveFigure {
  margin-top: 4px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ebebeb;
  margin-bottom: 11px;
}
.flyTop .erectFenge {
  width: 0px;
  height: 74px;
  border: 2px solid;
  border-image: linear-gradient(0deg, rgba(238, 175, 84, 0.00), rgba(255, 200, 119, 0.99) 49%, rgba(255, 200, 119, 0.00)) 2 2;
}
.RightBottomBottom {
  width: 306px;
  height: 38px;
  /* background: rgba(23, 11, 1, 0.50); */
  display: flex;
  margin-bottom: 15px;
  align-items: center;
  background-image: url(../../../src/assets/img/2dmap/paihang_bg.png);
}
.shortShuFenge {
  margin-left: 2px;
  width: 4px;
  height: 28px;
  margin-right: 6px;
}
.rightBottomBottomText {
  width: 100px;
  height: 16px;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.processStyle {
  width: 155px;
  height: 6px;
  margin-right: 10px;
  margin-left: 10px;
}
.RightBottomBottomFigure {
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.titleShuFenge {
  margin-left: 2px;
  width: 4px;
  height: 38px;
  margin-right: 6px;
}
.inspectionContentWrap .rightBottomTop .titleBgL {
  background: linear-gradient(90deg, rgba(255, 140, 77, 0.50) 0%, rgba(255, 140, 77, 0.00) 100%);
}

.inspectionContentWrap .rightBottomTop .titleBgR {
  background: linear-gradient(90deg, rgba(255, 85, 85, 0.50) 0%, rgba(255, 85, 85, 0.00) 100%);
}
.inspectionContentWrap .rightBottomTop .titleBgL,
.inspectionContentWrap .rightBottomTop .titleBgR {
  width: 140px;
  height: 38px;
  display: flex;
  align-items: center;
}
.ordinaryText {
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
  margin-right: 10px;
}
.contentFigure {
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
}
.ordinaryFigure {
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ebebeb;
}
.openLeftBtn{
  cursor: pointer;
  position: absolute;
  left: 5px;
  top:8px;
  z-index: 10;
}
.closeLeftBtn{
  cursor: pointer;
  position: absolute;
  right: -50px;
  top:2px;
}

.changeWithOpen {
  position: absolute;
//top: 495px;
//top: 470px;
  top: calc(50% + 40px );
  transform: translateY(-50%);
  right: 370px;
  width: 48px;
  cursor: pointer;
  z-index: 1003;
  background: transparent;
}

/* 右侧 */
.changeAirSpace {
  position: absolute;
//top: 495px;
  top: 500px;
  right: 12px;
  width: 50px;
  cursor: pointer;
  z-index: 1003;
  background: transparent;
}

.airSpaceBtnOne .chooseBtn {
  width: 100%;
  height: 48px;
  text-align: center;
  position: relative;
  align-items: center;
  display: flex;
  margin-bottom: 10px;
  z-index: 1004;
}

.changeWithOpen1 {
  position: absolute;
//top: 495px;
  top: calc(50% + 40px );
  transform: translateY(-50%);
  right: 405px;
  width: 156px;
  overflow: auto;
//height: 620px;
  max-height:  calc(100% - 360px);
  cursor: pointer;
  z-index: 1003;
  background: transparent;

}

.changeAirSpace1 {
  position: absolute;
//top: 495px;
  top: 250px;
  right: 56px;
  width: 150px;
  height: 620px;
  cursor: pointer;
  z-index: 1003;
  background: transparent;
}

.airSpaceBtn .chooseBtn {
  width: 100%;
  height: 34px;
  text-align: center;
  position: relative;
  align-items: center;
  display: flex;
  padding-left: 15px;
  margin-bottom: 10px;
  z-index: 1004;
}


.changeWithOpen1 .airSpaceBtn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.airSpaceBtn {
  position: relative;
}

.airSpaceBtn .chooseBtn img {
  position: absolute;
  top: 10px;
  right: 0px;
  margin-bottom: 15px;
}

.changeWithOpen1 .airSpaceBtn .chooseBtn {
  width: 100%;
}

.changeWithOpen .airSpaceBtn .chooseBtn {
  margin-bottom: 24px;
}

.area {
  position: relative;
  width: 156px;
  height: 45px;
}

.equip {
  position: relative;
  width: 156px;
  height: 300px;
}

.population {
  position: relative;
  width: 156px;
  height: 45px;
}
.airPointLine1{
  position: relative;
  width: 156px;
  height: 180px;
}
.Active {
  background-image: url(../../assets/img/2dmap/er_ji_click.png);
  background-repeat: no-repeat;
}

.noActive {
  background-image: url(../../assets/img/2dmap/er_ji_normal.png);
  background-repeat: no-repeat;
}

.changeWithOpenXianArea1 {
  position: absolute;
//top: 495px;
  /* top: 5px; */
  top: 0;
  right: 40px;
  width: 5px;
  height: 100%;
  cursor: pointer;
  z-index: 1003;
  background-image: url(../../assets/img/2dmap/she_bei_er_ji_bar.png);
}
.chooseBtn div {
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: center;
  color: #ffffff;
  /* margin-bottom: 5px; */
}


.changeAirSpace1 .airSpaceBtn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}


.changeWithOpenXianEquip {
  position: absolute;
//top: 495px;
  top: 0;
  right: 40px;
  width: 5px;
  height: 250px;
  cursor: pointer;
  z-index: 1003;
  background-image: url(../../assets/img/2dmap/she_bei_er_ji_bar.png);
}

.changeWithOpenXianAirPointLine {
  position: absolute;
//top: 495px;
  top: 0;
  /* todo */
  right: 40px;
  width: 5px;
  height: 120px;
  cursor: pointer;
  z-index: 1003;
  background-size: contain;
  background-image: url(../../assets/img/2dmap/she_bei_er_ji_bar.png);
}


.task-item_2d_realTask{
  display: flex;
  width: 100%;
  height: auto;
//line-height: 38px;
  background: #170b01;
  border-radius: 6px;
  margin-bottom: 6px;
  align-items: center;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
  box-sizing: border-box;
  padding-left: 5px;
}
.listAll_2d .warn_2d{
  background: linear-gradient(
    90deg,
    rgba(255, 150, 0, 0.8),
    rgba(71, 160, 255, 0.2)
  );
}
.listAll_2d .alarm_2d {
  background: linear-gradient(
    90deg,
    rgba(218, 0, 1, 0.8),
    rgba(71, 160, 255, 0.11)
  );
}
</style>



// WEBPACK FOOTER //
// src/components/home/ThreedPlayback.vue